

export const urlHelpers = {
  instagram: {
    validate: (url) => {
      if (!url) return true;
      try {
        const urlObj = new URL(url);
        return (
          urlObj.hostname === 'instagram.com' ||
          urlObj.hostname === 'www.instagram.com'
        ) && urlObj.pathname.length > 1;
      } catch {
        return false;
      }
    },
    format: (url) => {
      if (!url) return '';
      try {
        const urlObj = new URL(url);
        return `https://instagram.com${urlObj.pathname}`;
      } catch {
        // If it's just a username, construct the URL
        if (url.startsWith('@')) url = url.substring(1);
        return `https://instagram.com/${url.replace(/[^a-zA-Z0-9_]/g, '')}`;
      }
    },
    errorMessage: 'Please enter a valid Instagram profile URL or username'
  },
  youtube: {
    validate: (url) => {
      if (!url) return true;
      try {
        const urlObj = new URL(url);
        return (
          urlObj.hostname === 'youtube.com' ||
          urlObj.hostname === 'www.youtube.com' ||
          urlObj.hostname === 'youtu.be'
        );
      } catch {
        return false;
      }
    },
    format: (url) => {
      if (!url) return '';
      try {
        return new URL(url).href;
      } catch {
        return url;
      }
    },
    errorMessage: 'Please enter a valid YouTube URL'
  }
};

